import React from 'react';

import PropTypes from 'prop-types';

import './absgear.scss';

class AbsoluteGear extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      src: undefined,
    };
    this.move = (scrollTop) => {
      // eslint-disable-next-line
      if (this.ref && this.top < scrollTop + AbsoluteGear.windowHeight + 250 && this.top > scrollTop - 250 && this.ref.offsetParent !== null) {
        if (this.state.src === undefined) {
          this.setState({ src: this.props.src });
        }
        this.ref.style.transform = `rotate(${scrollTop / this.props.speed}deg)`;
      }
    };
    this.recalculate = (scrollTop) => {
      if (this.ref) {
        this.ref.style.transform = '';
        this.top = this.ref.getBoundingClientRect().top + scrollTop;
        this.move(scrollTop);
      }
    };
    this.attachRef = (e) => {
      this.ref = e;
    };
  }

  componentDidMount() {
    if (!AbsoluteGear.gearList) {
      AbsoluteGear.gearList = [];
      AbsoluteGear.getScrollTop = () => window.pageYOffset || document.documentElement.scrollTop;
      const animate = () => {
        const scrollTop = AbsoluteGear.getScrollTop();
        AbsoluteGear.gearList.forEach((gear) => {
          gear.move(scrollTop);
        });
      };
      const onResize = () => {
        const scrollTop = AbsoluteGear.getScrollTop();
        AbsoluteGear.windowHeight = window.innerHeight;
        AbsoluteGear.gearList.forEach((gear) => {
          gear.recalculate(scrollTop);
        });
      };
      window.addEventListener('scroll', () => {
        requestAnimationFrame(animate);
      });
      window.addEventListener('resize', () => {
        onResize();
      });
      window.addEventListener('load', () => {
        onResize();
      });
      onResize();
    }
    AbsoluteGear.gearList.push(this);
    this.recalculate(AbsoluteGear.getScrollTop());
  }

  componentWillUnmount() {
    AbsoluteGear.gearList.splice(AbsoluteGear.gearList.indexOf(this), 1);
  }

  render() {
    return (
      <div ref={this.attachRef} className={`absolute-gear ${this.props.className}`}>
        <img src={this.state.src} alt="" />
      </div>
    );
  }
}


AbsoluteGear.propTypes = {
  className: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  speed: PropTypes.number,
};

AbsoluteGear.defaultProps = {
  speed: 10,
};

export default AbsoluteGear;



// WEBPACK FOOTER //
// ./src/components/AbsoluteGear/index.jsx